import { Reveal } from '../components/Reveal';
import { Arrow } from '../components/Atoms';
import { HeroGraph } from '../graphs/HeroGraph';

export function Hero() {
  return (
    <section className="hero" data-screen-label="01 Hero">
      <div className="wrap">
        <div className="hero-grid">
          <Reveal className="hero-copy">
            <div className="eyebrow">
              <span className="tag">v0</span>
              <span>réseau social musical</span>
            </div>
            <h1>
              <span className="row1">Vois ce que tes</span>
              <span className="row1">amis écoutent.</span>
              <span className="row2">
                <em className="accent">
                  Quelle que soit{' '}
                  <span className="accent-word">
                    leur app.
                    <svg className="squiggle" viewBox="0 0 200 12" preserveAspectRatio="none" fill="none" strokeWidth="2" strokeLinecap="round">
                      <path d="M2 7 Q 26 1, 50 7 T 98 7 T 146 7 T 194 7" stroke="currentColor" />
                    </svg>
                  </span>
                </em>
              </span>
            </h1>
            <p className="hero-sub">
              Apple Music, Deezer, SoundCloud, YouTube — un seul fil musical, en temps réel,{' '}
              <b>sans murs entre tes amis</b>. furtif.fm est la couche sociale ouverte qui relie ce que les plateformes séparent.
            </p>
            <div className="hero-cta">
              <a href="#acces" className="btn">Demander un accès anticipé <Arrow /></a>
              <a href="#manifeste" className="ulink">Lire le manifeste &nbsp;→</a>
            </div>
          </Reveal>

          <Reveal className="graph-stage" aria-hidden="true">
            <HeroGraph />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
